import { render, staticRenderFns } from "./ConveniosForm.vue?vue&type=template&id=4c0a1c28&"
import script from "./ConveniosForm.vue?vue&type=script&lang=ts&"
export * from "./ConveniosForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConveniosForm.vue?vue&type=style&index=0&id=4c0a1c28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports